"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Effect", {
  enumerable: true,
  get: function get() {
    return _Effect["default"];
  }
});
exports["default"] = void 0;

var _NotificationBadge = _interopRequireDefault(require("./components/NotificationBadge"));

var _Effect = _interopRequireDefault(require("./components/Effect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _NotificationBadge["default"];
exports["default"] = _default;